const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPipOn(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.26 -5.192)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(2.26 5.192)",
    style: {
      fill: "rgba(0,0,0,.75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "container",
    transform: "translate(2.26 5.192)",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1329",
    d: "M774.7 23.388a.981.981 0 0 0-.054-.268 1.006 1.006 0 0 0-.217-.327l-.009-.006a1 1 0 0 0-.315-.209.984.984 0 0 0-.388-.077h-4.494a1 1 0 0 0 0 2h2.084l-4.292 4.292a1 1 0 1 0 1.414 1.414l4.294-4.294V28a1 1 0 1 0 2 0v-4.5a.869.869 0 0 0-.023-.112z",
    style: {
      fill: "current"
    },
    transform: "translate(-743.462 -10.309)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1330",
    d: "M773.722 38a1 1 0 0 0-1 1v2.088l-4.294-4.294a1 1 0 0 0-1.414 1.414l4.292 4.292h-2.084a1 1 0 0 0 0 2h4.5a1.005 1.005 0 0 0 .7-.287l.009-.006a1 1 0 0 0 .217-.327.981.981 0 0 0 .054-.268.869.869 0 0 0 .023-.113V39a1 1 0 0 0-1.003-1z",
    style: {
      fill: "current"
    },
    transform: "translate(-743.462 -10.309)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1331",
    d: "M756.138 24.5h2.084a1 1 0 0 0 0-2h-4.494a.993.993 0 0 0-.7.286l-.009.006a.989.989 0 0 0-.217.327.961.961 0 0 0-.055.271 1.013 1.013 0 0 0-.022.11V28a1 1 0 1 0 2 0v-2.087l4.294 4.294a1 1 0 1 0 1.414-1.414z",
    style: {
      fill: "current"
    },
    transform: "translate(-743.462 -10.309)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1332",
    d: "m759.016 36.793-4.294 4.294V39a1 1 0 1 0-2 0v4.5a1.013 1.013 0 0 0 .022.11.961.961 0 0 0 .055.271.989.989 0 0 0 .217.327l.009.006a1 1 0 0 0 .7.287h4.5a1 1 0 0 0 0-2h-2.084l4.292-4.292a1 1 0 0 0-1.414-1.414z",
    style: {
      fill: "current"
    },
    transform: "translate(-743.462 -10.309)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPipOn);
export default __webpack_public_path__ + "static/media/btn-pip-on.9d5268994a736262d378c7a336de222d.svg";
export { ForwardRef as ReactComponent };